import { motion } from "framer-motion";
import React from "react";
import "./ConfettiStyle.scss";

// Animation Variants for framer motion animation
const animVariants = {
  opened: {
    opacity: 1,
  },
  closed: {
    opacity: 0,
  },
};

// React Functional component for rendering the confetti
// or party poppers
export default function ConfettiComponent({ open }) {
  return (
    <>
      <motion.div
        variants={animVariants}
        initial={{ opacity: 0 }}
        animate={open ? "opened" : "closed"}
        transition={{ type: "ease" }}
        className="confetti"
      >
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
        <div className="confetti-piece"></div>
      </motion.div>
    </>
  );
}
